export const configRootFields = {
  ERP_MASTER: 'erpMaster',
  ERP_INVENTORY: 'erpInventory',
  ERP_PRICING: 'erpPricing',
  ERP_ORDER_CREATE: 'erpOrderCreate',
  ERP_RECONCILIATION: 'erpReconciliation',
  BLOCK_SALE_POS: 'blockSaleOnPos',
  LAST_MILE: 'lastMile',
  SMTP: 'smtp',
  INVOICE: 'invoice',
  FRESH: 'freshSystem',
  MAGENTO: 'magentoApi',
  SQL: 'sql',
  EXPRESSION: 'cronExpression',
  RMA_REASON: 'rmaReasons',
  RMA_CONDITIONS: 'rmaConditions',
}

export const ERP_FIELDS = {
  USERNAME: 'username',
  PASSWORD: 'password',
  URL: 'url',
  BEARER_TOKEN: 'bearerToken',
}

export const configurationsFields = {
  // Cron Expression
  EXPRESSION_MASTER: {
    parentKey: configRootFields.EXPRESSION,
    key: 'master',
    label: 'Master Data Cron Expression',
  },
  EXPRESSION_INVENTORY: {
    parentKey: configRootFields.EXPRESSION,
    key: 'inventory',
    label: 'Inventory Cron Expression',
  },
  EXPRESSION_PRICING: {
    parentKey: configRootFields.EXPRESSION,
    key: 'pricingTempToMain',
    label: 'Temp to Main Pricing Cron Expression',
  },
  EXPRESSION_ORDER_SYNC: {
    parentKey: configRootFields.EXPRESSION,
    key: 'orderSync',
    label: 'Order Sync Cron Expression',
  },
  EXPRESSION_RECONCILIATION: {
    parentKey: configRootFields.EXPRESSION,
    key: 'reconciliation',
    label: 'Reconciliation Cron Expression',
  },

  // SQL
  SQL_USER_ERP_DB: {
    parentKey: configRootFields.SQL,
    key: 'useErpDb',
    label: 'ERP Source',
  },
  SQL_HOST: {
    parentKey: configRootFields.SQL,
    key: 'host',
    label: 'Host',
  },
  SQL_PORT: {
    parentKey: configRootFields.SQL,
    key: 'port',
    label: 'Port',
  },
  SQL_DATABASE_NAME: {
    parentKey: configRootFields.SQL,
    key: 'databaseName',
    label: 'Database Name',
  },
  SQL_USERNAME: {
    parentKey: configRootFields.SQL,
    key: 'username',
    label: 'Username',
  },
  SQL_PASSWORD: {
    parentKey: configRootFields.SQL,
    key: 'password',
    label: 'Password',
  },

  // SMTP
  SMTP_HOST: {
    parentKey: configRootFields.SMTP,
    key: 'host',
    label: 'Host',
  },
  SMTP_USERNAME: {
    parentKey: configRootFields.SMTP,
    key: 'username',
    label: 'Username',
  },
  SMTP_PASSWORD: {
    parentKey: configRootFields.SMTP,
    key: 'password',
    label: 'Password',
  },
  SMTP_FROM_NAME: {
    parentKey: configRootFields.SMTP,
    key: 'fromName',
    label: 'From Name',
  },
  SMTP_FROM_EMAIL: {
    parentKey: configRootFields.SMTP,
    key: 'fromEmail',
    label: 'From Email',
  },

  // Invoice
  INVOICE_PHONE: {
    parentKey: configRootFields.INVOICE,
    key: 'phone',
    label: 'Phone Number',
  },
  INVOICE_ADDRESS: {
    parentKey: configRootFields.INVOICE,
    key: 'address',
    label: 'Address',
  },
  INVOICE_REG_NO: {
    parentKey: configRootFields.INVOICE,
    key: 'vatRegNo',
    label: 'VAT Registration Number',
  },

  // Magento API
  MA_AGGREGATOR: {
    parentKey: configRootFields.MAGENTO,
    key: 'aggregator',
    label: 'Aggregator',
  },
  MA_STORE: {
    parentKey: configRootFields.MAGENTO,
    key: 'store',
    label: 'Store',
  },
  MA_LIMIT_PRICING: {
    parentKey: configRootFields.MAGENTO,
    key: 'pricingLimit',
    label: 'Pricing API Limit',
  },
  MA_LIMIT_INVENTORY: {
    parentKey: configRootFields.MAGENTO,
    key: 'inventoryLimit',
    label: 'Inventory API Limit',
  },
  // Other
  MAX_UPLOAD_SIZE: {
    key: 'maxUploadSize',
    label: 'Max Upload Size',
  },
  ADMIN_EMAIL: {
    key: 'adminEmail',
    label: 'Admin Email',
  },
  FRESH_BARCODE_PREFIX: {
    key: 'freshBarcodePrefix',
    label: 'Fresh System Barcode Prefix',
  },
  LOG_DELETION_PERIOD: {
    key: 'logDeletionPeriod',
    label: 'Log Deletion Period',
  },
  MAX_CONCURRENT_AGGREGATORS: {
    key: 'maxConcurrentAggregators',
    label: 'Max Concurrent Aggregators',
  },
} as const

export type ManualCronFields = {
  lastUpdatedDateTime: string
}

export const expressionType: Record<string, string> = {
  [configurationsFields.EXPRESSION_MASTER.key]:
    configurationsFields.EXPRESSION_MASTER.label,
  [configurationsFields.EXPRESSION_INVENTORY.key]:
    configurationsFields.EXPRESSION_INVENTORY.label,
  [configurationsFields.EXPRESSION_PRICING.key]:
    configurationsFields.EXPRESSION_PRICING.label,
  [configurationsFields.EXPRESSION_ORDER_SYNC.key]:
    configurationsFields.EXPRESSION_ORDER_SYNC.label,
  [configurationsFields.EXPRESSION_RECONCILIATION.key]:
    configurationsFields.EXPRESSION_RECONCILIATION.label,
}
